import React, { Component } from 'react';
import ReactDOM from "react-dom"
import { Map, InfoWindow, Marker, GoogleApiWrapper } from 'google-maps-react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import './styles.css';
import api from '../../services/api';
import CommentsCard from '../Modal/CommentsCard/index'
import StatisticsCard from '../Modal/StatisticsCard/index'
// Icons
import alert_icon_0 from '../../assets/alerta/alerta_0.png';
import alert_icon_1 from '../../assets/alerta/alerta_1.png';
import alert_icon_2 from '../../assets/alerta/alerta_2.png';
import alert_icon_3 from '../../assets/alerta/alerta_3.png';
import alert_icon_4 from '../../assets/alerta/alerta_4.png';
import alert_icon_5 from '../../assets/alerta/alerta_5.png';
import { ReactComponent as CrossHairIcon } from '../../assets/crosshairs-gps.svg'

export class MapContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latitude: localStorage.getItem('@la') ? localStorage.getItem('@la') : -20.398259 ,
            longitude: localStorage.getItem('@l0') ? localStorage.getItem('@lo') : -43.507726,
            selectedPark: null,
            selectedMarker: {},
            showingInfoWindow: false,
            denuncias: [],
            markerLat: null,
            markerLng: null,
            mapRef:  null,
            showModal: false,
            comments:[],
            showStatistics: false,
            statistics:[],
        }
    }
    handleShowComments = async () =>{
        this.setState({
            showModal:true,
        })
        const params = {
            "spotId":this.state.selectedMarker._id
        }
        const response = await api.get('/spot/denunciations', { params })
        this.setState({
            comments:response.data.denunciations
        })
        // console.log(this.state.comments)
    } 

    loadDenuncias = async () => {
        const params = {
            "latitude":localStorage.getItem('@la')? localStorage.getItem('@la') : this.state.latitude,
            "longitude":localStorage.getItem('@lo')? localStorage.getItem('@lo'): this.state.longitude
        }
        const response = await api.get('/spot/show', { params });
        // console.log(response, 'SpotShow');
        this.setState({
            denuncias: response.data,
        })
    }

    getCurrentCoordinates = () => {
        navigator.geolocation.getCurrentPosition(location => {
            const { latitude, longitude } = location.coords;
            this.setState({
                latitude: latitude,
                longitude: longitude
            });
            //console.log(this.state.latitude + "  :  " + this.state.longitude)
            localStorage.getItem('@la') ? console.log('s') : window.location.reload()
            localStorage.setItem('@la',latitude)
            localStorage.setItem('@lo', longitude)
        }, (err) => {
            console.log(err);
            //if the user doesnt allow get position, map is gonna open in ouro preto 
            localStorage.setItem('@la',-20.398259)
            localStorage.setItem('@lo', -43.507726)
        });
    }
    componentDidMount = () => {
        this.getCurrentCoordinates();
        this.loadDenuncias();
    }
    
    onInfoWindowOpen(props, e) {
        const button = (
            <button 
                id='details-button'
                className='button-showComments' 
                onClick={e => {this.handleShowComments()}}
            >Ver detalhes</button>)
        ReactDOM.render(React.Children.only(button), document.getElementById("button"));
    }
    handleClose = () => {
        this.setState({
            showModal:false,
        })
    }

    handleOpenStatistics = () => {
        this.setState({
            showStatistics:true,
        })
    }
    handleCloseStatistics = () => {
        this.setState({
            showStatistics:false,
        })
    }

    render() {
        return (
            <div className='map-container' >
                <Map
                    //onClick={this.hidenLoginForm}
                    google={this.props.google}
                    zoom={14}
                    initialCenter={{ //if the user doesnt allow the system to get his position, the map is gonna be centered in ouro preto
                        lat: localStorage.getItem('@la') ? localStorage.getItem('@la') : -20.398259,
                        lng: localStorage.getItem('@lo') ? localStorage.getItem('@lo'): -43.507726,
                    }}
                    containerStyle={{
                        // --header-height definido no global.css
                        height: 'calc(100% - var(--header-height))',
                        marginTop: 'var(--header-height)',
                        // Permite que a sombra do header seja projetada sobre o mapa
                        zIndex: -1
                    }}
                    onReady={(props, map) => this.setState({ mapRef : map })}
                >

                    {this.state.denuncias.map((denuncia) => (
                        <Marker className='teste'
                            key={denuncia._id}
                            position={{
                                lat: denuncia.location.coordinates[1],
                                lng: denuncia.location.coordinates[0]
                            }}
                            onClick={() => {
                                this.setState({
                                    showingInfoWindow: true,
                                    selectedMarker: denuncia,
                                    markerLat: denuncia.location.coordinates[1],
                                    markerLng: denuncia.location.coordinates[0],
                                });
                                // console.log(this.state.selectedMarker);
                            }}
                            icon={{
                                url: {
                                    0: alert_icon_0,
                                    1: alert_icon_1,
                                    2: alert_icon_2,
                                    3: alert_icon_3,
                                    4: alert_icon_4,
                                    5: alert_icon_5,
                                  }[getAlertLevel(denuncia.riskAverage)],
                                scaledSize: new window.google.maps.Size(30, 30)
                            }}
                        />

                    ))}


                        <InfoWindow
                            visible={this.state.showingInfoWindow}

                            pixelOffset={new window.google.maps.Size(0, -30)}

                            onCloseClick={() => {
                                this.setState({
                                    showingInfoWindow:false,
                                    selectedMarker: null,
                                })
                            }}
                            position={{
                                lat: Number(this.state.markerLat),
                                lng: Number(this.state.markerLng)
                            }}

                            onOpen={e => {
                                this.onInfoWindowOpen(this.props, e)
                            }}
                        >
                            
                            <div className='infoWindow'>
                                <h6 className='denuncia-title'>{this.state.selectedMarker.establishment}</h6>
                                <div className="infoWindow-description">
                                    <p className="denuncia-nivel">
                                        {'Grau de risco: ' +
                                            {
                                                0: 'Não há denúncias',
                                                1: 'Leve',
                                                2: 'Moderado',
                                                3: 'Grave',
                                                4: 'Muito grave',
                                                5: 'Máximo',
                                            }[getAlertLevel(this.state.selectedMarker.riskAverage)]
                                        }
                                    </p> <br/>
                                    <div id='button'/>
                                    
                                </div>
                            </div>

                        </InfoWindow>
                </Map>

                <button
                    id='center-button'
                    className='center-map-button'
                    type='button'
                    onClick={() => {
                        this.state.mapRef.setZoom(15);
                        // Move o mapa para a localização
                        // (De forma suave se a região estiver carregada)
                        this.state.mapRef.panTo({
                            lat: this.state.latitude,
                            lng: this.state.longitude
                        });
                    }}
                >
                    <CrossHairIcon className='button-icon'/>
                </button>

                {/* Details modal */}
                <Dialog
                    open={this.state.showModal}
                    onClose={e => {this.handleClose()}}
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth='xs'
                >

                    <DialogContent dividers> {/*={scroll === 'paper'}*/}

                        <div className='modal-header'>
                            <h1 className='modal-header-title'>Detalhes do local</h1><br/>
                            <p className='modal-header-description'>Nome: <p className='modal-header-description des-color'> {this.state.selectedMarker.establishment}</p></p>
                            <p className='modal-header-description'>Grau de risco: 
                                <p className='modal-header-description des-color'>{{
                                                1: 'Leve',
                                                2: 'Moderado',
                                                3: 'Grave',
                                                4: 'Muito grave',
                                                5: 'Máximo',
                                            }[getAlertLevel(this.state.selectedMarker.riskAverage)]}
                                </p>
                            </p>
                            <p className='modal-header-description'>Total de denúncias: <p className='modal-header-description des-color'>{this.state.selectedMarker.quantity}</p></p>
                            <button id ='statistics-button'className='modal-header-button' onClick={e => {this.handleOpenStatistics()}}>
                                <p className='modal-header-button-text'>Estatísticas</p> 
                            </button>
                        </div>

                        <p className='modal-header-comments'>Comentários:</p>
                        

                        {
                            this.state.comments.length !== 0 && this.state.comments.description!==''  ?
                                this.state.comments.map( item =>
                                    <CommentsCard key={item._id}
                                        date={item.created}
                                        comment={item.description}
                                        answerDate={item.created}
                                        answer={item.answers? item.answers : 'ntem'}
                                    />
                                ) :
                                <p>Este local ainda não possui comentários.</p>
                        }
                                
                        
                    </DialogContent>

                    <DialogActions>
                        <button id ='close-details-button'className='button-showComments button-closeModal' onClick={e => {this.handleClose()}}>
                            Fechar
                        </button>
                    </DialogActions>

                </Dialog>
                
                {/* Statistics Modal */}
                <Dialog
                    open={this.state.showStatistics}
                    onClose={e => {this.handleCloseStatistics()}}
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth='sm'
                >
                    <DialogContent dividers>

                        <h1 className='modal-header-title'>Estatísticas</h1>

                        <StatisticsCard statistics={this.state.selectedMarker.estatistics}/>
                        
                    </DialogContent>

                    <DialogActions>
                        <button id ='close-statistics-button'className='button-showComments button-closeModal' onClick={e => {this.handleCloseStatistics()}}>
                            Voltar
                        </button>
                    </DialogActions>

                </Dialog>

            </div>
        );
    }
}

function getAlertLevel(riskAverage) {
    if (riskAverage > 0.774) return 5;
    else if (riskAverage > 0.5424) return 4;
    else if (riskAverage > 0.274) return 3;
    else if (riskAverage > 0.024) return 2;
    else if (riskAverage === 0) return 0;
    else return 1;
  }

export default GoogleApiWrapper({
    apiKey: ("AIzaSyAgPOsQ_Swp_Pmgvi2SKcOMeKWIssTbsos")
})(MapContainer)